var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    { staticClass: "jitsi-layer", class: { minimized: _vm.isMinimized } },
    [
      _c(
        "section",
        {
          ref: "fullscreenRef",
          staticClass: "jitsi-panel",
          class: {
            maximized: _vm.isMaximized,
            minimized: _vm.isMinimized,
          },
          attrs: { role: "dialog", "aria-modal": "true" },
        },
        [
          _c("header", { staticClass: "jitsi-header" }, [
            _c("div", { staticClass: "jitsi-title" }, [
              _vm._v(
                "\n        " +
                  _vm._s(_vm.data.subject || _vm.$t("MEETING")) +
                  "\n      "
              ),
            ]),
            _c(
              "div",
              { staticClass: "jitsi-actions" },
              [
                _c(
                  "b-button",
                  {
                    staticClass: "no-border",
                    attrs: {
                      size: "sm",
                      title: _vm.isMinimized
                        ? _vm.$t("RESTORE")
                        : _vm.$t("MINIMIZE"),
                    },
                    on: { click: _vm.toggleMinimize },
                  },
                  [
                    _c("i", {
                      class: _vm.isMinimized
                        ? "fa-solid fa-up-right-and-down-left-from-center"
                        : "fa-solid fa-minus",
                    }),
                  ]
                ),
                !_vm.isMinimized
                  ? _c(
                      "b-button",
                      {
                        staticClass: "no-border",
                        attrs: {
                          size: "sm",
                          title: _vm.isMaximized
                            ? _vm.$t("EXIT_FULL_SCREEN")
                            : _vm.$t("MAXIMIZE"),
                        },
                        on: { click: _vm.toggleMaximize },
                      },
                      [
                        _c("i", {
                          class: _vm.isMaximized
                            ? "fa-solid fa-down-left-and-up-right-to-center"
                            : "fa-solid fa-up-right-and-down-left-from-center",
                        }),
                      ]
                    )
                  : _vm._e(),
                _c(
                  "b-button",
                  {
                    staticClass: "no-border",
                    attrs: { size: "sm", title: _vm.$t("END_MEETING") },
                    on: {
                      click: function ($event) {
                        return _vm.closeMeeting(false)
                      },
                    },
                  },
                  [_c("i", { staticClass: "fa-solid fa-xmark" })]
                ),
              ],
              1
            ),
          ]),
          _c("div", { staticClass: "jitsi-body" }, [
            _c("div", {
              ref: "jitsiContainerRef",
              staticClass: "jitsi-container",
            }),
          ]),
        ]
      ),
    ]
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }